module.exports = __webpack_public_path__ + "static/img/bg_2_7.a23f61e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_7.png
// module id = zqcV
// module chunks = 3